import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebaseConfig';

export async function signInWithToken(token: string) {
  await signInWithCustomToken(auth, token);
}
